import gsap from 'gsap'

const AUTOPLAY_DELAY = 5000

export default class Explore {
	constructor() {
		this.sections = document.querySelectorAll('[data-explore]')
		this.#init()
	}

	#init() {
		this.sections.forEach(section => this.#setupSection(section))
	}

	#setupSection(section) {
		const buttons = section.querySelectorAll('[data-explore-button]')
		const blocks = section.querySelectorAll('[data-explore-block]')
		if (!buttons.length || !blocks.length) return

		let activeIndex = 0
		let currentTween = null
		let timer = null

		const getChildren = block => block.querySelectorAll(':scope > *')

		blocks.forEach((block, i) => {
			gsap.set(block, { autoAlpha: i === 0 ? 1 : 0 })
			gsap.set(getChildren(block), {
				autoAlpha: i === 0 ? 1 : 0,
				y: i === 0 ? 0 : 20,
			})
		})

		const scheduleNext = () => {
			clearTimeout(timer)
			timer = setTimeout(() => {
				setActive((activeIndex + 1) % blocks.length)
			}, AUTOPLAY_DELAY)
		}

		const setActive = index => {
			if (index === activeIndex) {
				scheduleNext()
				return
			}

			buttons.forEach((btn, i) =>
				btn.classList.toggle('active', i === index)
			)

			const outgoing = blocks[activeIndex]
			const incoming = blocks[index]
			activeIndex = index

			currentTween?.kill()

			const tl = gsap.timeline({ onComplete: scheduleNext })
			tl.to(getChildren(outgoing), {
				autoAlpha: 0,
				y: -20,
				duration: 0.35,
				ease: 'power2.in',
				stagger: 0.05,
			})
				.set(outgoing, { autoAlpha: 0 })
				.set(incoming, { autoAlpha: 1 })
				.fromTo(
					getChildren(incoming),
					{ autoAlpha: 0, y: 20 },
					{
						autoAlpha: 1,
						y: 0,
						duration: 0.5,
						ease: 'power2.out',
						stagger: 0.08,
					}
				)
			currentTween = tl
		}

		buttons.forEach((button, i) => {
			button.addEventListener('click', () => setActive(i))
		})

		scheduleNext()
	}
}
